export const PDF_TYPOGRAPHY = {
  FONT_FAMILY: {
    PRIMARY: 'Helvetica',
    BOLD: 'Helvetica-Bold',
    ITALIC: 'Helvetica-Oblique',
  },

  FONT_SIZE: {
    XXSMALL: 8,
    XSMALL: 9,
    SMALL: 10,
    MEDIUM: 12,
    LARGE: 14,
    XLARGE: 16,
    XXLARGE: 18,
    XXXLARGE: 20,
    TITLE: 24,
  },

  FONT_WEIGHT: {
    NORMAL: 'normal',
    MEDIUM: 'medium',
    BOLD: 'bold',
  },

  LINE_HEIGHT: {
    TIGHT: 1,
    NORMAL: 1.2,
    RELAXED: 1.5,
  },
}
